<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Subscribers List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <span class="style-16">Total Subscriptions: {{ totalIncome | currency }}</span>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items-per-page="1000" :items="subscribers" :search="search">
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="openModal(item)" color="editIcon" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- subscription fee template -->
              <template v-slot:item.expiryStatus="{ item }">
                <span style="color: green; font-weight: bold;" v-if="item.expiryStatus == 0">Active</span>
                <span style="color: red; font-weight: bold;" v-if="item.expiryStatus == 1">Expired</span>
              </template>
              <!-- end -->

              <!-- date template -->
              <template v-slot:item.expiryDate="{ item }">
                {{ item.expiryDate | date }}
              </template>
              <!-- end -->

              <!-- subscription fee template -->
              <template v-slot:item.SubscriptionFee="{ item }">
                {{ item.SubscriptionFee | currency }}
              </template>
              <!-- end -->


              <!-- action template -->
              <template v-slot:item.edit="{ item }">
                <v-btn text @click="openOacpModal(item)" color="accent">Update OACP</v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.disable="{ item }">
                <v-btn text @click="openDisableModal(item)" color="accent"><v-icon left>mdi-close</v-icon>Disable
              </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <!-- start of modal -->
        <v-dialog v-model="dialog" max-width="650px">
          <v-toolbar color="accent" dense dark>
            <v-toolbar-title>End of trial date update</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-text-field dense outlined v-model="activeUser.name" readonly></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field dense outlined v-model="activeUser.email" readonly></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field dense label="Subscription Fee" type="number" outlined
                    v-model="SubscriptionFee"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field dense label="Status" type="number" outlined
                    v-model="activeUser.expiryStatus"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <DatePicker @date="setDate" :myDate="date" :title="`Expiry Date`"></DatePicker>
                </v-col>
                <v-col cols="6">
                  <v-btn color="primary" dark :loading="loader" @click="updateSubscription">Update</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal -->



        <!-- start of disable modal -->
        <v-dialog v-model="disableDialog" max-width="650px">
          <v-toolbar color="accent" dense dark>
            <v-toolbar-title>Disable Subscriber</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="disableDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-row class="text--primary subtitle-2">
                <v-col cols="6">{{ activeUser.name }}</v-col>
                <v-col cols="6">{{ activeUser.email }}</v-col>

                <v-col cols="12" class="style-16">
                  Are you sure you want to disable this subscriber ?
                </v-col>

                <v-col cols="12">
                  <v-btn color="primary" class="float-right" dark :loading="loader" @click="disableSubscriber">Yes,
                    Disable
                    Subscriber</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal -->

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    totalIncome: 0,
    disableDialog: false,
    dialog: false,
    oacpDialog: false,
    CardCode: null,
    SubscriptionFee: null,
    oacpRecord: {},
    loader: false,
    activeUser: {},
    date: null,
    headers: [
      { text: "Account No", value: "refNo" },
      { text: "Email", value: "email" },
      { text: "Subs. Fee", value: "SubscriptionFee" },
      { text: "Wallet Bal", value: "EWalletBalance" },
      { text: "Expiry Date", value: "expiryDate" },
      { text: "Status", value: "expiryStatus" },
      { text: "Action", value: "action" },
      { text: "Disable", value: "disable" },
    ],
    subscribers: []
  }),
  methods: {
    setDate(date) {
      this.date = date;
    },
    openModal(user) {
      this.activeUser = user;
      this.dialog = true;
    },
    openDisableModal(user) {
      this.activeUser = user;
      this.disableDialog = true;
    },
    openOacpModal(user) {
      this.activeUser = user;
      this.CardCode = user.oacp.CardCode;
      this.SubscriptionFee = user.oacp.SubscriptionFee;
      this.oacpDialog = true;
    },
    disableSubscriber() {
      const self = this;
      self.loader = true;
      var id = parseInt(this.activeUser.id);
      this.$store
        .dispatch("get", `/disable-subscriber/${id}`)
        .then(() => {
          self.loader = false;
          location.reload();
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSubscribers() {
      const self = this;
      this.$store
        .dispatch("get", `/get-subscribers`)
        .then(res => {
          self.subscribers = res.ResponseData.subscribers;
          self.totalIncome = res.ResponseData.totalIncome;
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    updateSubscription() {
      // save data
      const url = `/update-subscription-data/${this.activeUser.id}`;
      var date = this.date;
      console.log(date, " date ")
      const data = {
        subscriptionFee: parseFloat(this.SubscriptionFee),
        expiryDate: date,
        expiryStatus:  parseInt(this.activeUser.expiryStatus)
      };

      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getSubscribers();
  }
};
</script>